import { render } from "./AdminCallRequestsView.vue?vue&type=template&id=41ebb13d&scoped=true&ts=true"
import script from "./AdminCallRequestsView.vue?vue&type=script&lang=ts"
export * from "./AdminCallRequestsView.vue?vue&type=script&lang=ts"

import "@/assets/admin-crud.css?vue&type=style&index=0&id=41ebb13d&scoped=true&lang=css&external"
import "./AdminCallRequestsView.vue?vue&type=style&index=1&id=41ebb13d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ebb13d"]])

export default __exports__